import Vue from "vue";
import Vuex from "vuex";
import httpuserprofile from './js/http-userprofile.js'
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    showsuccessmessage: false,
    authenticated: false,
    userType: "",
    showupdatedmessage: false,
    showmessage: false,
    selectedUser: '',
    selectedCompany : '',
    selectedJob : '',
    searchtext: '',
    selectedTab: '',
    profileStrength : 'Very Low',
    profileStrengthPercentage : 0,
    totalWorkExperience : 0,
    addedContactInfo : false,
    routeName : null,
    notificationCount : 0,
    profilePicLink : null,
    remainingDays : null,
    trailAccountFlag : null
  },

  mutations: {
    SET_USER_TYPE: (state, newValue) => {
      state.userType = newValue;
    },
    fetchPrivacyPolicyUpdated() {
      var vm = this
      httpuserprofile.get('/userprofile/getPrivacyPolicy?userType=candidate')
      .then((response) => {
        console.log("privacyPolicy : ", response)
        localStorage.setItem("privacyPolicyVersion", response.data.version)
      })
      .catch((e) => {
        console.log(e)
      })
    },
    fetchTermsConditionsUpdated() {
      var vm = this
      httpuserprofile.get('/userprofile/getTermsAndConditions?userType=candidate')
     .then((response) => {
        console.log(response)
        localStorage.setItem("termsConditionsVersion", response.data.version)
     }).catch((e) => {
       console.log(e)
     })
   },
  },
  actions: {
    setUserType: (state, newValue) => {
      state.commit("SET_USER_TYPE", newValue);
    }
  },
  getters: {},
  computed: {}
});
